import { Button, Dialog, DialogActions, DialogContent } from '@mui/material'
import type { DateTimePeriod } from 'shared/types/DateTimePeriod'

interface LimitedDataForPeriodDialogProps {
    id?: string
    keepMounted?: boolean
    open: boolean
    onClose: () => void
    selectedPeriod?: DateTimePeriod
    periodContainingData?: DateTimePeriod
}

export const LimitedDataForPeriodDialog = (props: LimitedDataForPeriodDialogProps): JSX.Element => {
    const {
        open,
        keepMounted,
        onClose,
        periodContainingData,
        ...other
    } = props

    const handleClose = () => {
        onClose?.()
    }

    return (
        <Dialog
            sx={{ '& .MuiDialog-paper': { width: 'auto', maxHeight: '590px' } }}
            keepMounted
            maxWidth="xs"
            open={open}
            {...other}
        >
            <DialogContent dividers>
                <h3>{`For the selected period, we have data`} <br />{`from ${periodContainingData?.from.toFormat('M/dd/yyyy') } to ${periodContainingData?.to.toFormat('M/dd/yyyy') }`}</h3>
            </DialogContent>
            <DialogActions>
                <Button
                    autoFocus
                    onClick={handleClose}
                >
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    )
}